<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::sidebar-->
      <sidebar-component classMenu="AccidentAdd"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    Pengajuan Detail
                  </h6>
                  <button
                    class="btn btn-default btn-sm float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>
                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->

                  <form
                    ref="formElement"
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="d-flex justify-content-between align-items-baseline mb-2"
                    ></div>

                    <!-- DATA ORDER -->
                    <div class="card mb-3">
                      <div class="card-header">DATA ORDER</div>
                      <div class="card-body">
                        <div class="row mb-2">
                          <div class="col-md-3">
                            <label>Load Id</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="dataOrder.load_id"
                              disabled
                            />
                          </div>
                          <div class="col-md-3">
                            <label>Jenis Truck</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="dataOrder.type_truck"
                              disabled
                            />
                          </div>
                          <div class="col-md-3">
                            <label>NMK Driver</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="dataOrder.nmkDriver"
                              disabled
                            />
                          </div>
                          <div class="col-md-3">
                            <label>Nopol</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="dataOrder.nopol"
                              disabled
                            />
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-md-3">
                            <label>Nama Driver</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="dataOrder.namaDriver"
                              disabled
                            />
                          </div>
                          <div class="col-md-3">
                            <label>Cabang</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="dataOrder.branch"
                              disabled
                            />
                          </div>
                          <div class="col-md-3">
                            <label>Carrier</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="dataOrder.carrier"
                              disabled
                            />
                          </div>

                          <div class="col-md-3">
                            <label>Status</label>
                            <input
                              type="text"
                              class="form-control"
                              value="PENGAJUAN"
                              disabled
                            />
                          </div>
                        </div>

                        <!-- Table Data Order -->

                        <!-- <div class="d-flex justify-content-end mb-2">
                                                    <span class="btn-success btn-sm  cursor-pointer"
                                                        @click="tambahOrder">
                                                        <i class="mdi mdi-plus"></i>
                                                    </span>
                                                </div> -->

                        <div class="table-responsive">
                          <table class="table table-bordered mt-3">
                            <thead class="table-light">
                              <tr>
                                <!-- <th>Action</th> -->
                                <th>Status</th>
                                <th>Auto Transfer</th>
                                <th>Approval Remark</th>
                                <th>Order No</th>
                                <th>Customer Code</th>
                                <th>Customer Name</th>
                                <th>Sap Code</th>
                                <th>Tanggal Order</th>
                                <th>Pick Plan</th>
                                <th>Pick Name</th>
                                <th>Drop Plan</th>
                                <th>Drop Name</th>
                                <th>Charge Code</th>
                                <th>Charge Description</th>
                                <th>Rute</th>
                                <th>Type</th>
                                <th>Nominal</th>
                                <th style="width: 500px">Remarks</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(item, idx) in dataOrder.orders"
                                :key="idx"
                              >
                                <!-- Action -->
                                <td>{{ item.addcost_status }}</td>
                                <td>{{ item.auto_transfer }}</td>
                                <td>{{ item.approval_remarks }}</td>
                                <!-- Order No -->
                                <td>
                                  <!-- v-select kalau belum selesai -->
                                  <!-- <v-select
                                                                        v-if="!item.done"
                                                                        :options="orderNoList"
                                                                        label="text"
                                                                        :reduce="o => o.value"
                                                                        v-model="item.orderNo"
                                                                        @input="pilihOrder(idx)"
                                                                    ></v-select> -->
                                  {{ item.orderNo }}

                                  <!-- teks kalau sudah selesai -->
                                </td>

                                <td>{{ item.customerCode }}</td>
                                <td>{{ item.customerName }}</td>
                                <td>{{ item.sapCode }}</td>
                                <td>{{ item.tanggalOrder }}</td>
                                <td>{{ item.pickPlan }}</td>
                                <td>{{ item.pickName }}</td>
                                <td>{{ item.dropPlan }}</td>
                                <td>{{ item.dropName }}</td>
                                <td>{{ item.charge_code }}</td>

                                <td>{{ item.charge_description }}</td>
                                <td>{{ item.rute }}</td>
                                <td>{{ item.type }}</td>
                                <td>
                                  <input
                                    v-if="!item.done"
                                    class="form-control"
                                    name="nominal"
                                    v-model="item.nominal"
                                    type="number"
                                  />
                                  <span v-else>{{ item.nominal }}</span>
                                </td>
                                <td>
                                  <textarea
                                    cols="100"
                                    v-if="!item.done"
                                    class="form-control"
                                    name="remarks"
                                    v-model="item.remarks"
                                  ></textarea>

                                  <span v-else>{{ item.remarks }}</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <!-- HISTORY -->
                    <div class="card mb-3">
                      <div class="card-header">HISTORY</div>
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table table-bordered table-sm">
                            <thead class="table-light">
                              <tr>
                                <th>No</th>
                                <th>Status</th>
                                  <th>Status Nett Off</th>
                                <th>Tanggal Nett Off</th>
                                <th>User Nett Off</th>
                                <th>Tanggal Pengajuan</th>
                                <th>Tanggal Approval</th>
                                <th>Auto Transfer</th>
                                <th>Approval Remarks</th>
                                <th>Nominal</th>
                                <th>Order No</th>
                                <th>Charge Code</th>
                                <th>Charge Description</th>
                                <th>Cust Code</th>
                                <th>Customer Name</th>
                                <th>SAP Code</th>
                                <th>Tanggal Order</th>
                                <th>Pick Plan</th>
                                <th>Pick Name</th>
                                <th>Drop Plan</th>
                                <th>Drop Name</th>
                                <th>Rute</th>
                                <th>Type</th>
                                <th>Remarks</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr
                                v-for="(item, idx) in historyAddcost"
                                :key="idx"
                              >
                                <td>{{ idx + 1 }}</td>
                                <td>{{ item.addcost_status }}</td>
                                 <td>
                                   <div class="form-check form-switch d-flex align-items-center justify-content-center gap-2">
                                  
                              

                                      <input
                                        class="form-check-input"
                                        type="checkbox"
                                        v-model="item.netoff_status"
                                        true-value="Yes"
                                        false-value="No"
                                        v-if="item.addcost_status=='APPROVED'"
                                        :disabled="item.netoff_status === 'Yes'"
                                        @click.prevent="toggleNetoff(idx, item, dataOrder?.load_id)"
                                      />


                                    <span class="fw-bold">
                                      {{ item.netoff_status === 'Yes' ? 'Yes' : 'No' }}
                                    </span>
                                  </div>
                                 </td>
                                 
                                <td>{{ item.netoff_at }}</td>
                                <td>{{ item.nettoff_user }}</td>

                                <td>{{ item.request_at }}</td>
                                <td>{{ item.approve_at }}</td>
                                <td>{{ item.auto_transfer }}</td>
                                <td>{{ item.approval_remarks }}</td>
                                <td>{{ formatCurrency(item.amount) }}</td>
                                <td>{{ item.order_no }}</td>
                                <td>{{ item.charge_code }}</td>
                                <td>{{ item.charge_code_description }}</td>
                                <td>{{ item.transport_order_header.company.code }}</td>
                                <td>{{ item.transport_order_header.company.name }}</td>
                                <td>{{ item.transport_order_header.company.sap_code }}</td>
                                <td>{{ item.transport_order_header.order_date }}</td>
                                <td>{{ item.transport_order_header.pick_plan }}</td>
                                <td>{{ item.transport_order_header.pick_name }}</td>
                                <td>{{ item.transport_order_header.dest_plan }}</td>
                                <td>{{ item.transport_order_header.dest_name }}</td>
                                <td>{{ item.rute }}</td>
                                <td>{{ item.type }}</td>
                                <td>{{ item.remarks }}</td>
                              </tr>

                              <tr v-if="!historyAddcost.length">
                                <td colspan="40" class="text-center">
                                  No data
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <!-- DATA KLAIM -->

                    <!-- DETAIL KLAIM -->

                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <!-- <button class="btn btn-primary float-end btn-sm" type="submit">
                                                <i class="link-icon" data-feather="save"></i>
                                                {{ $t("submitFormTxt") }}
                                            </button> -->
                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->
        <!-- <modal-unloading :showModal="showModalUnloading" :data="this.dataModal" @closeModal="closeMyModal">
                </modal-unloading> -->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import myMixinAddress from "@/middleware/mixinAddress.js";
// import Datepicker from "vuejs-datepicker";
// import multiselect from "vue-multiselect";
// import moment from 'moment'
// import modalUnloading from "@/components/modal/modalUnloading.vue";
// import CurrencyInput from "@/components/_partials/inputCurrency";
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import moment from "moment";
// import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  name: "PengajuanAdd",
  props: {},
  mixins: [myMixinAddress],
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    // "modal-unloading": modalUnloading,
    // multiselect: multiselect,
    // DateRangePicker,
    // CurrencyInput,
    // Datepicker
  },
  data() {
    const startDate = new Date();
    const endDate = new Date();

    return {
      historyAddcost: [],
      disabledBeforeLoad: true,
      vehicle_no: "",
      bebanVendor: 0,
      bebanKantor: 0,
      bebanDriver: 0,

      fetchVehicleNo: [],
      opens: "center",

      category: "",
      fetchCategory: [],
      fetchCategoryStatus: [],

      orderNoList: [],

      editorData: "<p>Halo, ini CKEditor 4 gratis!</p>",
      editorConfig: {
        versionCheck: false,
        toolbar: [
          {
            name: "clipboard",
            items: ["Cut", "Copy", "Paste", "Undo", "Redo"],
          },
          { name: "editing", items: ["Find", "Replace", "SelectAll"] },
          {
            name: "basicstyles",
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "-",
              "RemoveFormat",
            ],
          },
          {
            name: "paragraph",
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
            ],
          },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
          {
            name: "insert",
            items: [
              "Image",
              "Table",
              "HorizontalRule",
              "SpecialChar",
              "Smiley",
            ],
          },
          { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "tools", items: ["Maximize", "ShowBlocks", "Source"] },
        ],
      },

      fetchSumberInformasi: [],
      fetchChargeCode: [],
      // dataOrder: {
      //     orders: []
      // },

      driver_nmk: "",
      fetchDriverNmk: [],
      fetchAccidentArea: [],
      fetchHaul: ["Short Haul", "Long Haul"],
      haul: "",
      penyebab_langsung: "",
      accident_area: "",
      fetchPenyebabLangsung: [],
      caused: "",
      fetchCaused: [],

      fetchKerusakan: [],
      kerusakans: "",
      fetchTipeKejadian: [],
      tipe_kejadians: "",
      fetchPenyebabDasar: [],
      penyebab_dasars: "",

      locale: {
        format: "dd mmm yyyy H:MM:ss",
        separator: " - ",
      },

      localeP: {
        format: "dd mmm yyyy",
        separator: " - ",
      },

      accident_date: {
        startDate,
        endDate,
      },

      active_date: {
        startDate: null,
        endDate: null,
      },

      fetchNmkDriver: [],
      fetchNopol: [],

      accident_date_complete: {
        startDate: null,
        endDate: null,
      },

      fetchCaseResult: [],
      case_result: "",

      rate: "",
      fetchRate: [],

      fetchLoadNumber: [],
      loadNumber: [],

      fetchDirectCauseDetail: [],
      directCauseDetail: "",

      fetchProvinsiTujuan: [],
      ProvinsiTujuan: [],

      fetchKotaTujuan: [],
      KotaTujuan: [],

      fetchSubCustomer: ["Industrial", "Consumer", "MT", "Pallet", "E-COM"],
      SubCustomer: [],

      showModalUnloading: false,

      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      permision_role: [],
      userData: "",
      companyCode: "",
      forms: {},

      disabledDate: {},
      dataModal: {},
      fetchLoadId: [],
      load_id: "",

      dataOrder: {
        loadId: "",
        type_truck: "",
        nmkDriver: "",
        branch: "",
        driver_number: "",
        nopol: "",
        namaDriver: "",
        carrier: "",
        branch_name: "",
        orders: [],
      },
      dataKlaim: {
        aging: 0,
        status: "NEW",
        noKlaim: "",
        sumberInfo: "Customer",
        cabang: "Jakarta",
        laporan: "",
        nmkDriver: "",
        namaDriver: "",
        tglKejadian: {
          startDate,
          endDate,
        },
        tglPengajuan: {
          startDate,
          endDate,
        },
        pemeriksaan: "",
        penyelesaian: "",
        details: [
          {
            produk: "",
            keterangan: "",
            klaimKe: "Vendor",
            kategori: "Claim DG",
            jumlah: 0,
            typePaket: "Kilogram",
            harga: 0,
          },
        ],
      },
      lampiran: [{ nama: "Berita Acara", file: null }],
    };
  },

  watch: {
    "dataKlaim.tglPengajuan"(newDate) {
      ///console.log(newDate);
      if (!newDate.startDate) {
        this.dataKlaim.aging = 0;
        return;
      }

      const today = new Date();
      const selectedDate = new Date(newDate.startDate);

      // hitung selisih dalam hari
      const diffTime = selectedDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      this.dataKlaim.aging = diffDays;
    },
  },
  computed: {
    totalKlaim() {
      return this.dataKlaim.details.reduce(
        (sum, d) => sum + d.jumlah * d.harga,
        0
      );
    },
  },
  methods: {
    selectNmkDriver(ev) {
      this.dataKlaim.namaDriver = ev.driver_name;
    },

    selectNopol(ev) {
      this.dataKlaim.type_truck = ev.type_truck;
    },
    openMap() {},
    changeDisabled(ev) {
      this.forms.complete_date = "";
      this.disabledDate = {
        to: ev,
      };
    },
    clearLoad() {},

    inputChargeCode(ev, index) {
      console.log(this.dataOrder.orders[index]["charge_description"]);
      if (ev.description_overide) {
        this.dataOrder.orders[index]["charge_description"] =
          ev.description_overide;
      }
      console.log(this.dataOrder.orders);
    },

    loadChargeCode() {
      this.fetchChargeCode = [];
      const baseURI = this.$settings.endPoint + `rm-charge-code`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchChargeCode = response.data.datas.data;
      });
    },


     toggleNetoff(index, item, load_id) {
  this.isLoading = true;

  this.$swal({
    title: this.$t("areYouSure"),
    text: "Apakah anda yakin untuk melakukan Net Off untuk addcost ini, kalau anda klik ya maka tidak akan bisa di rollback !",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes!",
  }).then((result) => {

    // ❌ CANCEL
    if (!result.isConfirmed) {
      this.isLoading = false;
      this.$set(this.historyAddcost[index], "netoff_status", "No");
      return;
    }

    // ✔️ CALL API
    const baseURI =
      this.$settings.endPoint +
      `transport-order-accessorial/net-off/${item.transport_order_accessorial_id}`;

    this.$http.post(baseURI, {}, { timeout: 30000 })
      .then((response) => {

        const res = response.data;

        // ===============================
        // ✔️ SUCCESS 200
        // ===============================
        if (res.status === 200) {
          this.$set(this.historyAddcost[index], "netoff_status", "Yes");

          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: "Data berhasil dikirim",
          });

          this.loadHistoryAddcost(load_id);
        }

        // ===============================
        // ❌ ERROR 422 DARI BE
        // ===============================
        else if (res.status === 422) {

          const messages = res?.errors?.message || ["Terjadi kesalahan"];

          this.$set(this.historyAddcost[index], "netoff_status", "No");

          this.$swal.fire({
            icon: "error",
            title: "Gagal Net Off",
            html: `
              <ul style="text-align:left; padding-left:15px;">
                ${messages.map(m => `<li>${m}</li>`).join("")}
              </ul>
            `,
            confirmButtonText: "OK",
          });
        }

        // ===============================
        // ❌ STATUS LAIN
        // ===============================
        else {
          this.$set(this.historyAddcost[index], "netoff_status", "No");

          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Terjadi kesalahan yang tidak diketahui",
          });
        }

        this.isLoading = false;
      })

      // ===============================
      // ❌ ERROR HTTP (network / 500 / dll)
      // ===============================
      .catch((error) => {
        this.isLoading = false;

        this.$set(this.historyAddcost[index], "netoff_status", "No");

        if (error.code === "ECONNABORTED") {
          this.error(this.$t("check_internet_connection_txt"));
          return;
        }

        if (error.response) {
          if (error.response.status === 422) {
            const messages =
              error.response.data?.errors?.message || ["Validation error"];

            this.$swal.fire({
              icon: "error",
              title: "Gagal Net Off",
              html: `
                <ul style="text-align:left; padding-left:15px;">
                  ${messages.map(m => `<li>${m}</li>`).join("")}
                </ul>
              `,
            });
          } else if (error.response.status === 500) {
            this.$router.push("/server-error");
          } else if (error.response.status === 401) {
            this.$router.push("/authorized-error");
          } else {
            this.$router.push("/page-not-found");
          }
        }
      });
  });
},


    asyncChargeCode(ev) {
      this.fetchChargeCode = [];
      const baseURI =
        this.$settings.endPoint + `rm-charge-code?description_overide=` + ev;
      return this.$http.get(baseURI).then((response) => {
        this.fetchChargeCode = response.data.datas.data;
      });
    },

    formatCurrency(value) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
      }).format(value || 0);
    },

    loadVehicleNo() {
      const baseURI = this.$settings.endPointCt + `master-truck`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchVehicleNo = response.data.datas.data;
      });
    },

    loadDriverNmk() {
      const baseURI = this.$settings.endPointCt + `master-driver`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchDriverNmk = response.data.datas.data;
      });
    },

    selectDriverNmk(driver) {
      this.forms.vehicle_owner = driver.branch_name;
    },

    selectAccidentArea(accident) {
      if (this.forms.vehicle_owner == accident) {
        this.haul = "Short Haul";
      }
    },

    loadSumberInformasi() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=sumInf`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchSumberInformasi = response.data.datas;
      });
    },

    tambahDetail() {
      this.dataKlaim.details.push({
        produk: "",
        keterangan: "",
        klaimKe: "Vendor",
        kategori: "Claim DG",
        jumlah: 0,
        typePaket: "Kilogram",
        harga: 0,
      });
    },
    hapusDetail(index) {
      this.dataKlaim.details.splice(index, 1);
    },

    loadCause() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=cauac`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchCaused = response.data.datas;
      });
    },

    loadRate() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=ratac`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchRate = response.data.datas;
      });
    },

    loadPenyebabLangsung() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=dirca`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchPenyebabLangsung = response.data.datas;
      });
    },

    loadDirectCauseDetail() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=penla`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchDirectCauseDetail = response.data.datas;
      });
    },
    loadCaseResult() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=casre`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchCaseResult = response.data.datas;
      });
    },

    selectChangeLoad(ev) {
      this.dataOrder.transport_order_header_id = ev.transport_order_header_id;
      this.dataOrder.type_truck = ev.type_truck;
      this.dataOrder.nmkDriver = ev.driver_id;
      this.dataOrder.nopol = ev.vehicle_no;
      this.dataOrder.namaDriver = ev.driver_name;
      this.dataOrder.carrier = ev.carrier;
      this.dataOrder.driver_number = ev.driver_number;
      this.dataOrder.branch_name = ev.branch_name;
      this.dataOrder.company = ev.company;
      this.dataOrder.load_id = ev.load_id;
      this.dataOrder.load_group = ev.load_group;

      // this.dataKlaim.nmkDriver = {
      //     nmk: ev.driver_id,
      //     driver_name: ev.driver_name
      // }

      // this.dataKlaim.namaDriver = ev.driver_name;

      // this.dataKlaim.nopol = {
      //     vehicle_no: ev.vehicle_no,
      //     type_truck: ev.type_truck

      // }

      // this.dataKlaim.type_truck = ev.type_truck;
      this.orderNoList = ev.loadid;
      // this.loadordeNo(ev.load_id)
      // if (ev.driver_id != null) {
      //     this.loadDriverDeposit(ev.driver_id)
      // }
    },

    asyncSearchNmkDriver(ev) {
      const baseURI =
        this.$settings.endPointCt +
        `driver-nmk/get-data-nmks?limit=999999&nmk=${ev}`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchNmkDriver = response.data.datas;
      });
    },

    loadNmkDriver() {
      const baseURI =
        this.$settings.endPointCt + `driver-nmk/get-data-nmks?limit=999999`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchNmkDriver = response.data.datas.data;
      });
    },

    asyncSearchNopol(ev) {
      const baseURI =
        this.$settings.endPointCt + `master-truck?limit=10&vehicle_no=${ev}`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchNopol = response.data.datas;
      });
    },

    loadNopol() {
      const baseURI = this.$settings.endPointCt + `master-truck?limit=10`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchNopol = response.data.datas.data;
      });
    },

    loadTipeKejadian() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=kejad`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchTipeKejadian = response.data.datas;
      });
    },

    loadKerusakan() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=kerus`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchKerusakan = response.data.datas;
      });
    },

    loadPenyebabDasar() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=sebab`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchPenyebabDasar = response.data.datas;
      });
    },

    loadAccidentArea() {
      const baseURI = this.$settings.endPointCt + `branch`;
      return this.$http.get(baseURI).then((response) => {
        var resp = response.data.datas;
        for (let index = 0; index < resp.data.length; index++) {
          const branch = resp.data[index].branch_name;
          this.fetchAccidentArea.push(branch);
        }
        // var data={
        //   resp.data.branch_name
        // }
        //this.fetchAccidentArea = response.data.datas;
      });
    },

    asyncSearchDriverNmk(ev) {
      const baseURI =
        this.$settings.endPointCt + `master-driver?driver_id=` + ev;
      return this.$http.get(baseURI).then((response) => {
        this.fetchDriverNmk = response.data.datas.data;
      });
    },

    asyncSearchVehicleNo(ev) {
      const baseURI =
        this.$settings.endPointCt + `master-truck?vehicle_no=` + ev;
      return this.$http.get(baseURI).then((response) => {
        this.fetchVehicleNo = response.data.datas.data;
      });
    },

    loadordeNo(load_id) {
      const baseURI =
        this.$settings.endPoint + `/claim/get-order-by-loadid/` + load_id;

      return this.$http.get(baseURI).then((response) => {
        this.orderNoList = response.data.datas;
      });
    },

    loadDriverDeposit(nmk_driver) {
      const baseURI =
        this.$settings.endPoint + `/claim/get-saldo-akhir-driver/` + nmk_driver;

      return this.$http.get(baseURI).then((response) => {
        let driver = response.data.datas;
        this.dataOrder.driver_deposit = driver?.saldo_akhir;
      });
    },

    tambahClaimFile() {
      this.lampiran.push({ nama: "", file: null });
    },
    hapusClaimFile(index) {
      this.lampiran.splice(index, 1);
    },
    onFileChange(event, index) {
      const file = event.target.files[0];
      this.lampiran[index].file = file;
    },

    tambahOrder() {
      this.dataOrder.orders.push({
        orderNo: null,
        customerCode: "",
        customerName: "",
        sapCode: "",
        tanggalOrder: "",
        pickPlan: "",
        pickName: "",
        dropPlan: "",
        dropName: "",
        shipwith_ref: "",
        done: false,
        charge_code: "",
        charge_description: "",
        nominal: 0,
        remarks: "",
      });
    },

    hapusOrder(index) {
      this.dataOrder.orders.splice(index, 1);
    },
    pilihOrder(index, data) {
      console.log(this.dataOrder.company);
      this.dataOrder.orders[index].customerCode = this.dataOrder.company.code;
      this.dataOrder.orders[index].customerName = this.dataOrder.company.name;
      this.dataOrder.orders[index].sapCode = this.dataOrder.company.sap_code;
      this.dataOrder.orders[index].tanggalOrder = data.order_date;
      this.dataOrder.orders[index].pickPlan = data.pick_plan;
      this.dataOrder.orders[index].pickName = data.pick_name;
      this.dataOrder.orders[index].dropPlan = data.dest_plan;
      this.dataOrder.orders[index].dropName = data.dest_name;
      this.dataOrder.orders[index].shipwith_ref = data.shipwith_ref;
      console.log(this.dataOrder.orders);
    },

    loadLoadId() {
      const baseURI =
        this.$settings.endPoint +
        `control-tower/transport-order-header/list-load-id`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchLoadId = response.data.datas;
      });
    },

    asyncSearchLoadId(ev) {
      const baseURI =
        this.$settings.endPoint +
        `control-tower/transport-order-header/list-load-id?load_id=${ev}`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchLoadId = response.data.datas;
      });
    },

    openModal() {
      const baseURI = this.$settings.endPointCt + "blujay-order/select";
      this.$http.get(baseURI).then((response) => {
        this.dataModal = {
          detail: response.data.datas,
        };
        this.showModalUnloading = true;
      });
    },

    loadBlujay() {
      const baseURI = this.$settings.endPointCt + `blujay-order/select`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchLoadNumber = response.data.datas.data;
      });
    },

    asyncSearchLoadNumber(ev) {
      const baseURI =
        this.$settings.endPointCt + "blujay-order/select?load_id=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchLoadNumber = response.data.datas.data;
      });
    },

    // asyncSearchProvinsiTujuan() {
    //   const baseURI = this.$settings.endPoint + "postal-code/select-province/Indonesia";

    //   return this.$http.get(baseURI).then((response) => {
    //     this.fetchProvinsiTujuan = response.data.datas;
    //   });
    // },

    // "blujay_order_id",
    //       "load_number",
    //       "detail_order_id",
    //       "shipment_number",
    //       "shipment_date",
    //       "vehicle_no",
    //       "master_driver_id",
    //       "driver_nmk",
    //       "driver_name",
    //       "driver_hp",
    //       "tanggal_muat",
    //       "tanggal_bongkar",
    //       "provinsi_tujuan",
    //       "kota_tujuan",
    //       "sku",
    //       "route",
    //       "qty",
    //       "qty_return",
    //       "sub_customer",
    //       "description",

    // "blujay_order_id": 3539,
    //             "load_id": "60530857",
    //             "vehicle_no": "B9153FXS",
    //             "driver_nmk": null,
    //             "driver_name": null,
    //             "driver_hp": null,
    //             "name_rute": "pickup :LTLCIKARANG BARAT(GUDANG CML) - LTLLEGOK(PT JAYA SWARASA AGUNG TBK)",
    //             "drop": "LTLLEGOK(PT JAYA SWARASA AGUNG TBK)",
    //             "order_detail_id": 3515,
    //             "shipment_number": "2100437094",
    //             "shipment_date": "2000-01-01 01:01:01",
    //             "state_pick": "BT",
    //             "city": "TANGERANG",
    //             "region": "LEGOK",
    //             "state_drop": "BT",
    //             "vehicle_status": "ACTIVE",
    //             "driver_status": null,
    //             "route": "BT-BT",
    //             "leadtime": 1

    closeMyModal(ev) {
      console.log(ev.master_driver_id);
      if (ev !== null) {
        this.disabledBeforeLoad = false;
        this.forms.master_driver_id = ev.master_driver_id;
        this.forms.blujay_order_id = ev.blujay_order_id;
        this.forms.detail_order_id = ev.order_detail_id;
        this.forms.load_number = ev.load_id;

        this.vehicle_no = {
          vehicle_no: ev.vehicle_no,
        };

        this.forms.driver_nmk = ev.driver_nmk;
        this.forms.driver_name = ev.driver_name;
        this.forms.driver_hp = ev.driver_hp;
        this.forms.route = ev.name_rute;
        this.forms.shipment_number = ev.shipment_number;
        this.forms.shipment_date = ev.shipment_date;
        this.forms.tanggal_muat = ev.shipment_date;
        this.forms.order_number = ev.shipment_number;
        this.forms.driver_id = ev.driver_nmk;
        this.forms.vehicle_owner = ev.branch_name;
        this.driver_id = ev.driver_nmk;
        this.driver_nmk = ev.driver_nmk;
      }

      this.showModalUnloading = false;
    },

    capitalize(value) {
      if (!value) return "";
      value = value.toLowerCase();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },

    isNumberLatLong(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    resetForm() {
      this.forms = "";
    },

    loadCategoriStatus() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=catclm`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchCategoryStatus = response.data.datas;
      });
    },

    backForm() {
      window.location.href = "/addcost/pengajuan-addcost";
      // this.$router.push({ name: 'pengajuanaddcost' });
    },

    removeField(index, fieldType) {
      fieldType.splice(index, 1);
    },

    submitData() {
      this.isLoading = true;

      // Format tanggal pengajuan
      // if (this.dataKlaim.tglPengajuan) {
      //     const date = new Date(this.dataKlaim.tglPengajuan);
      //     const year = date.getFullYear();
      //     const month = String(date.getMonth() + 1).padStart(2, '0');
      //     const day = String(date.getDate()).padStart(2, '0');
      //     this.dataKlaim.tglPengajuan = `${year}-${month}-${day}`;
      // }

      // // Format tanggal kejadian
      // if (this.dataKlaim.tglKejadian) {
      //     const date = new Date(this.dataKlaim.tglKejadian);
      //     const year = date.getFullYear();
      //     const month = String(date.getMonth() + 1).padStart(2, '0');
      //     const day = String(date.getDate()).padStart(2, '0');
      //     this.dataKlaim.tglKejadian = `${year}-${month}-${day}`;
      // }

      // Buat FormData

      let formData = new FormData();

      // Data utama (string / number)

      // ======================
      // Array claim_order
      // ======================
      let detail = [];

      (this.dataOrder?.orders || []).forEach((item) => {
        detail.push({
          transport_order_header_id: this.dataOrder.transport_order_header_id,
          category: "empty",
          load_id: this.dataOrder.load_id,
          load_group: "-",
          carrier: this.dataOrder.carrier,
          type_truck: this.dataOrder.type_truck,
          number_stop: "0",
          charge_code: item.charge_code.charge_code,
          branch: this.dataOrder.branch_name,
          amount: item.nominal,
          remarks: item.remarks,
          order_no: item.orderNo.order_no,
          pick_plan: item.pickPlan,
        });
      });

      detail.forEach((item, index) => {
        Object.keys(item).forEach((key) => {
          formData.append(`detail[${index}][${key}]`, item[key] ?? "");
        });
      });

      console.log(formData);

      // Kirim request ke API
      const baseURI =
        this.$settings.endPoint + "transport-order-accessorial/create-multiple";
      this.$http
        .post(baseURI, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 50000,
        })
        .then((response) => {
          this.isLoading = false;
          if (response.data.status === 200) {
            this.success("Berhasil");
            var params = this.$onRandom(response.data.datas);
            window.location.href =
              "/addcost/pengajuan-addcost/detail/" +
              params +
              "?status=200&msg=Successfully";
            this.errors = [];
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          } else if (error.response) {
            if (error.response.status === 422) {
              // Ambil semua error message dari BE
              let errors = error.response.data.errors || {};

              // Gabungkan semua pesan error jadi list HTML
              let errorMessages = "";
              Object.keys(errors).forEach((key) => {
                errors[key].forEach((msg) => {
                  errorMessages += `<li>${msg}</li>`;
                });
              });

              this.$swal.fire({
                icon: "error",
                title: "Validation Error",
                html: `<ul style="text-align:left;">${errorMessages}</ul>`,
                confirmButtonText: "OK",
              });
            } else if (error.response.status === 500) {
              this.error(error.response.data.errors.message);
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    changeDriverNmk(driver) {
      this.forms.driver_name = driver.driver_name;
      this.forms.driver_hp = driver.hp1;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    loadData(load_id) {
      var flag = this.$route.query?.flag;
      const baseURI =
        this.$settings.endPoint +
        "transport-order-accessorial/detail-multiple/" +
        load_id +
        "/" +
        flag;
      return this.$http.get(baseURI).then((response) => {
        // console.log(response);
        this.forms = response.data.datas;

        this.dataOrder = {
          load_id: this.forms.load_id,
          type_truck: this.forms.type_truck,
          nmkDriver: this.forms.driver_id,
          branch: this.forms.branch_name,
          driver_number: this.forms.driver_number,
          nopol: this.forms.vehicle_no,
          namaDriver: this.forms.driver_name,
          carrier: this.forms.carrier,
          branch_name: this.forms.branch_name,
          orders: [],
        };

        // this.loadDriverDeposit(forms.driver_nmk)
        // this.claim_id=forms.claim_id;
        // //this.status_claim=forms.claim_status;
        // this.dataOrder = {
        //     loadId: {
        //         load_id: forms.load_id,
        //     },
        //     type_truck: forms.truck_type,
        //     nmkDriver: forms.driver_nmk,
        //     driver_deposit: 0,
        //     driver_number: forms.driver_number,
        //     nopol: forms.vehicle_no,
        //     namaDriver: forms.driver_name,
        //     carrier: forms.carrier,
        //     branch_name: forms.branch,
        //     orders: [

        //     ]
        // };

        (this.forms?.transport_order_accessorial || []).forEach((item) => {
          this.dataOrder.orders.push({
            addcost_status: item.addcost_status,
            orderNo: item.order_no,
            customerCode: this.forms.company.code,
            customerName: this.forms.company.name,
            sapCode: this.forms.company.sap_code,
            tanggalOrder: this.forms.order_date,
            pickPlan: this.forms.pick_plan,
            pickName: this.forms.pick_name,
            dropPlan: this.forms.dest_plan,
            dropName: this.forms.dest_name,
            shipwith_ref: this.forms.shipwith_ref,
            done: true,
            charge_code: item.charge_code,
            charge_description: item.charge_code_description,
            nominal: item.amount,
            remarks: item.remarks,
            auto_transfer: item.auto_transfer,
            approval_remarks: item.approval_remarks,
            type: item.type,
            rute: item.rute,
          });
        });

        // this.status_claim={
        //     name:forms.claim_status
        // }

        // this.bebanDriver = forms.claim_driver;
        // this.bebanVendor = forms.claim_vendor;
        // this.bebanKantor = forms.claim_absorb;
        // // this.dataKlaim.tglPengajuan = forms.claim_date;
        // // this.dataKlaim.tglKejadian = forms.incident_date;
        // //this.dataKlaim.jamKejadian=
        // const incident_date = forms.incident_date;
        // const claim_date = forms.claim_date;
        // const [datePart, timePart] = incident_date.split(" ");
        // const [datePartClaim] = claim_date.split(" ");
        // this.dataKlaim = {
        //     aging: forms.aging,
        //     status: forms.claim_status,
        //     noKlaim: forms.klaim_id,
        //     sumberInfo: forms.source_of_information,
        //     cabang: forms.branch,
        //     nmkDriver: { nmk: forms.driver_nmk },
        //     namaDriver: forms.driver_name,
        //     type_truck: forms.truck_type,
        //     laporan: forms.incident_report,
        //     pemeriksaan: forms.incident_result,
        //     penyelesaian: forms.incident_settlement,
        //     tglPengajuan: datePartClaim,
        //     tglKejadian: datePart,
        //     jamKejadian: timePart,
        //     nopol: {
        //         vehicle_no: forms.vehicle_no
        //     },
        //     details: [
        //         // { produk: 'Kertas CME', keterangan: 'Produk Jadi', klaimKe: 'Vendor', kategori: 'Claim DG', jumlah: 42, typePaket: 'Kilogram', harga: 50000 }
        //     ]
        // };
        // console.log(this.dataKlaim);
        // (forms?.details || []).forEach((item) => {
        //     this.dataKlaim.details.push({
        //         produk: item.product_name,
        //         produk_id: item.product_id,
        //         keterangan: item.product_description,
        //         klaimKe: item.claim_to,
        //         kategori: item.product_category,
        //         jumlah: item.package_qty,
        //         typePaket: item.package_type,
        //         harga: item.cost_per_package
        //     });
        // });
        // this.lampiran = [

        // ];

        // (forms?.attachments || []).forEach((item) => {
        //     this.lampiran.push({ nama: item.attachment_name, file: item.attachment_file });
        // });

        // (forms?.decisions || []).forEach((item) => {
        //     this.claim_decision.push(
        //         {
        //             claim_number: item.claim_number,
        //             payment_date:{ startDate:item.payment_date,endDate:item.payment_date},
        //             payment_amount:item.payment_amount,
        //             currency:{
        //                 name:item.currency
        //             },
        //             comment:item.comment
        //         });
        // });

        // this.decision_claim={
        //     name:forms.claim_decision
        // }

        // this.form={ name: 'asep', usernmae:res.username };
      });
    },

    loadHistoryAddcost(load_id) {
      const flag = this.$route.query?.flag;

      const baseURI = `${this.$settings.endPoint}/transport-order-accessorial/history/${load_id}/${flag}`;

      return this.$http
        .get(baseURI)
        .then((response) => {
          this.historyAddcost = response.data?.datas || [];

          console.log(
            "historyAddcost JSON:",
            JSON.stringify(this.historyAddcost, null, 2)
          );
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else if (error.response.status === 401) {
              this.$router.push("/authorized-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (
          permision.permission.controller ==
          "TransportOrderAccessorialController"
        ) {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_create) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    const formElement = this.$refs.formElement;
    if (formElement) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "readonly"
          ) {
            const inputs = formElement.querySelectorAll(".multiselect__input");
            inputs.forEach((input) => {
              input.removeAttribute("readonly"); // Hapus readonly setiap kali diubah
            });
          }
        });
      });

      const inputs = formElement.querySelectorAll(".multiselect__input");
      inputs.forEach((input) => {
        observer.observe(input, { attributes: true });
      });
    }
    this.fetchIt();
    //this.loadLoadId();

    var params = this.$onBehind(this.$route.params.id);
    var id = params[0];
    this.loadData(id);
    this.loadHistoryAddcost(id);

    this.loadChargeCode();
  },
};
</script>
<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}

.blur-content {
  filter: blur(5px);
  pointer-events: none;
}

.calendars[data-v-1ebd09d2] {
  display: -webkit-box;
  display: -ms-flexbox;
}

@media screen and (min-width: 339px) {
  .daterangepicker.single[data-v-1ebd09d2] {
    min-width: auto;
  }

  .daterangepicker.single.show-ranges.show-weeknumbers[data-v-1ebd09d2],
  .daterangepicker.single.show-ranges[data-v-1ebd09d2] {
    min-width: 360px !important;
  }
}

.input-group > .form-control,
.input-group > .typeahead.tt-input,
.input-group > .typeahead.tt-hint,
.select2-container--default
  .select2-search--dropdown
  .input-group
  > .select2-search__field,
.input-group > .form-select {
  background: white;
}

.datetimepicker-c {
  height: 35px;
}
</style>